import styled from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { device } from '@/styles/helpers';

const bg = getCDNImageUrl('/lp/wheel-fortune/bg.png');

export const ScWheelRegistration = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  margin-inline: auto;
  align-items: center;
  @media (${device.tablet}) {
    max-width: 512px;
    grid-template-columns: 1fr;
  }
  @media (${device.mobile}) {
    max-width: none;
    margin-left: -8px;
    width: calc(100% + 16px);
  }
  & > div {
    &.reg-box {
      background-color: ${({ theme }) => theme.whiteColor};
      color: ${({ theme }) => theme.blackColor};
      border-radius: 24px;
      padding: 32px;

      & > .reg-title {
        font-size: 32px;
        line-height: 40px;
        letter-spacing: 0.96px;
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 32px;

        @media (${device.mobile}) {
          color: ${({ theme }) => theme.blackColor} !important;
          margin-bottom: 16px;
          font-size: 28px;
          line-height: 36px;
          letter-spacing: 0.84px;
        }
      }

      @media (${device.mobile}) {
        & h3 {
          color: ${({ theme }) => theme.blackColor} !important;
        }
        padding: 16px;
        border-radius: 0 0 24px 24px;
      }

      & .reg-banner-btn {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      & form .reg-banner-btn {
        width: 100%;
        display: flex;
        justify-content: center;

        & > button {
          min-width: 204px;
          width: auto;
        }
      }
    }

    &.promo-box {
      max-height: 498px;
      height: 100%;
      margin: 28px 0;
      padding: 32px 0 0;
      border-top-left-radius: 24px;
      border-bottom-left-radius: 24px;
      background: url(${bg}) no-repeat center / cover;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: relative;
      & > .offer {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 10px;
        font-weight: 700;
        position: relative;
        & > span {
          font-size: 22px;
          line-height: 22px;
          letter-spacing: 0.647px;
          &:first-child {
            font-size: 27px;
            line-height: 32px;
          }
        }
        @media (${device.tablet}) {
          width: 100%;
          padding: 32px 16px;
          border-radius: 24px 24px 0 0;
          background: url(${bg}) no-repeat top / cover;
        }
      }
      @media (${device.tablet}) {
        margin: 0;
        padding: 0;
        flex-direction: column-reverse;
        background: none;
        & > img {
          width: 275px;
          height: 144px;
        }
      }
    }
  }

  & .submit-box {
    display: flex;
    justify-content: center;
  }
`;
